import repository from "../Repository";

export default {
  async list(screenId) {
    return await repository.post(
      "disaster_fixedphrase_mst_info",
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return await repository.post("disaster_fixedphrase_mst_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch("disaster_fixedphrase_mst_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.patch(
      "disaster_fixedphrase_mst_ope/delete",
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
